import coffee1 from '../static/coffee1.png'; // mild
import coffee2 from '../static/coffee2.png'; // classic
import coffee3 from '../static/coffee3.png'; // strong
import coffee4 from '../static/coffee4.png'; // latte
import coffee5 from '../static/coffee5.png'; // hot chocolate

import tea1 from '../static/tea1.png'; // forest berries
import tea2 from '../static/tea2.png'; // lime
import tea3 from '../static/tea3.png'; // blackcurrant
import tea4 from '../static/tea4.png'; // peach

import coffeenew1 from '../static/Coffee (1).jpg';
import coffeenew2 from '../static/Coffee (2).jpg';
import coffeenew3 from '../static/Coffee (3).jpg';
import coffeenew4 from '../static/Coffee (4).jpg';
import coffeenew5 from '../static/Coffee (5).jpg';
import coffeenew6 from '../static/Coffee (6).jpg';
import coffeenew7 from '../static/Coffee (7).jpg';
import coffeenew8 from '../static/Coffee (8).jpg';
import coffeenew9 from '../static/Coffee (9).jpg';
import coffeenew10 from '../static/Coffee (10).jpg';
import coffeenew11 from '../static/Coffee (11).jpg';
import coffeenew12 from '../static/Coffee (12).jpg';
import coffeenew13 from '../static/Coffee (13).jpg';
import coffeenew14 from '../static/Coffee (14).jpg';
import coffeenew15 from '../static/Coffee (15).jpg';
import coffeenew16 from '../static/Coffee (16).jpg';
import coffeenew17 from '../static/Coffee (17).jpg';
import coffeenew18 from '../static/Coffee (18).jpg';
import coffeenew19 from '../static/Coffee (19).jpg';
import coffeenew20 from '../static/Coffee (20).jpg';
import coffeenew21 from '../static/Coffee (21).jpg';
import coffeenew22 from '../static/Coffee (22).jpg';
import coffeenew23 from '../static/Coffee (23).jpg';
import coffeenew24 from '../static/Coffee (24).jpg';
import coffeenew25 from '../static/Coffee (25).jpg';
import coffeenew26 from '../static/Coffee (26).jpg';
import coffeenew27 from '../static/Coffee (27).jpg';
import coffeenew28 from '../static/Coffee (28).jpg';
import coffeenew29 from '../static/Coffee (29).jpg';
import coffeenew30 from '../static/Coffee (30).jpg';
import coffeenew31 from '../static/Coffee (31).jpg';
import coffeenew32 from '../static/Coffee (32).jpg';
import coffeenew33 from '../static/Coffee (33).jpg';
import coffeenew34 from '../static/Coffee (34).jpg';
import coffeenew35 from '../static/Coffee (35).jpg';
import coffeenew36 from '../static/Coffee (36).jpg';
import coffeenew37 from '../static/Coffee (37).jpg';
import coffeenew38 from '../static/Coffee (38).jpg';
import coffeenew39 from '../static/Coffee (39).jpg';
import coffeenew40 from '../static/Coffee (40).jpg';
import coffeenew41 from '../static/Coffee (41).jpg';
import coffeenew42 from '../static/Coffee (42).jpg';
import coffeenew43 from '../static/Coffee (43).jpg';
import coffeenew44 from '../static/Coffee (44).jpg';
import coffeenew45 from '../static/Coffee (45).jpg';
import coffeenew46 from '../static/Coffee (46).jpg';
import coffeenew47 from '../static/Coffee (47).jpg';
import coffeenew48 from '../static/Coffee (48).jpg';
import coffeenew49 from '../static/Coffee (49).jpg';
import coffeenew50 from '../static/Coffee (50).jpg';
import coffeenew51 from '../static/Coffee (51).jpg';
import coffeenew52 from '../static/Coffee (52).jpg';
import coffeenew53 from '../static/Coffee (53).jpg';
import coffeenew54 from '../static/Coffee (54).jpg';
import coffeenew55 from '../static/Coffee (55).jpg';
import coffeenew56 from '../static/Coffee (56).jpg';
import coffeenew57 from '../static/Coffee (57).jpg';
import coffeenew58 from '../static/Coffee (58).jpg';
import coffeenew59 from '../static/Coffee (59).jpg';
import coffeenew60 from '../static/Coffee (60).jpg';
import coffeenew61 from '../static/Coffee (61).jpg';
import coffeenew62 from '../static/Coffee (62).jpg';
import coffeenew63 from '../static/Coffee (63).jpg';
import coffeenew64 from '../static/Coffee (64).jpg';
import coffeenew65 from '../static/Coffee (65).jpg';
import coffeenew66 from '../static/Coffee (66).jpg';
import coffeenew67 from '../static/Coffee (67).jpg';
import coffeenew68 from '../static/Coffee (68).jpg';
import coffeenew69 from '../static/Coffee (69).jpg';
import coffeenew70 from '../static/Coffee (70).jpg';
import coffeenew71 from '../static/Coffee (71).jpg';
import coffeenew72 from '../static/Coffee (72).jpg';
import coffeenew73 from '../static/Coffee (73).jpg';
import coffeenew74 from '../static/Coffee (74).jpg';
import coffeenew75 from '../static/Coffee (75).jpg';
import coffeenew76 from '../static/Coffee (76).jpg';
import coffeenew77 from '../static/Coffee (77).jpg';
import coffeenew78 from '../static/Coffee (78).jpg';
import coffeenew79 from '../static/Coffee (79).jpg';
import coffeenew80 from '../static/Coffee (80).jpg';
import coffeenew81 from '../static/Coffee (81).jpg';
import coffeenew82 from '../static/Coffee (82).jpg';
import coffeenew83 from '../static/Coffee (83).jpg';
import coffeenew84 from '../static/Coffee (84).jpg';
import coffeenew85 from '../static/Coffee (85).jpg';
import coffeenew86 from '../static/Coffee (86).jpg';
import coffeenew87 from '../static/Coffee (87).jpg';
import coffeenew88 from '../static/Coffee (88).jpg';
import coffeenew89 from '../static/Coffee (89).jpg';
import coffeenew90 from '../static/Coffee (90).jpg';
import coffeenew91 from '../static/Coffee (91).jpg';
import coffeenew92 from '../static/Coffee (92).jpg';
import coffeenew93 from '../static/Coffee (93).jpg';

import beans from '../static/jacobs_monarch_bag_800g_front.avif';

export const PRODUCT_IMAGES: Record<string, string> = {
    // coffee sticks
    'mild-stick': coffee1,
    'classic-stick': coffee2,
    'strong-stick': coffee3,
    'latte-stick': coffee4,
    'hot-chocolate-stick': coffee5,

    // tea sticks
    'berry-tea-stick': tea1,
    'lime-tea-stick': tea2,
    'blackcurrant-tea-stick': tea3,
    'peach-tea-stick': tea4,
    'arabica-beans': beans,
    'coffeenew1': coffeenew1,
    'coffeenew2': coffeenew2,
    'coffeenew3': coffeenew3,
    'coffeenew4': coffeenew4,
    'coffeenew5': coffeenew5,
    'coffeenew6': coffeenew6,
    'coffeenew7': coffeenew7,
    'coffeenew8': coffeenew8,
    'coffeenew9': coffeenew9,
    'coffeenew10': coffeenew10,
    'coffeenew11': coffeenew11,
    'coffeenew12': coffeenew12,
    'coffeenew13': coffeenew13,
    'coffeenew14': coffeenew14,
    'coffeenew15': coffeenew15,
    'coffeenew16': coffeenew16,
    'coffeenew17': coffeenew17,
    'coffeenew18': coffeenew18,
    'coffeenew19': coffeenew19,
    'coffeenew20': coffeenew20,
    'coffeenew21': coffeenew21,
    'coffeenew22': coffeenew22,
    'coffeenew23': coffeenew23,
    'coffeenew24': coffeenew24,
    'coffeenew25': coffeenew25,
    'coffeenew26': coffeenew26,
    'coffeenew27': coffeenew27,
    'coffeenew28': coffeenew28,
    'coffeenew29': coffeenew29,
    'coffeenew30': coffeenew30,
    'coffeenew31': coffeenew31,
    'coffeenew32': coffeenew32,
    'coffeenew33': coffeenew33,
    'coffeenew34': coffeenew34,
    'coffeenew35': coffeenew35,
    'coffeenew36': coffeenew36,
    'coffeenew37': coffeenew37,
    'coffeenew38': coffeenew38,
    'coffeenew39': coffeenew39,
    'coffeenew40': coffeenew40,
    'coffeenew41': coffeenew41,
    'coffeenew42': coffeenew42,
    'coffeenew43': coffeenew43,
    'coffeenew44': coffeenew44,
    'coffeenew45': coffeenew45,
    'coffeenew46': coffeenew46,
    'coffeenew47': coffeenew47,
    'coffeenew48': coffeenew48,
    'coffeenew49': coffeenew49,
    'coffeenew50': coffeenew50,
    'coffeenew51': coffeenew51,
    'coffeenew52': coffeenew52,
    'coffeenew53': coffeenew53,
    'coffeenew54': coffeenew54,
    'coffeenew55': coffeenew55,
    'coffeenew56': coffeenew56,
    'coffeenew57': coffeenew57,
    'coffeenew58': coffeenew58,
    'coffeenew59': coffeenew59,
    'coffeenew60': coffeenew60,
    'coffeenew61': coffeenew61,
    'coffeenew62': coffeenew62,
    'coffeenew63': coffeenew63,
    'coffeenew64': coffeenew64,
    'coffeenew65': coffeenew65,
    'coffeenew66': coffeenew66,
    'coffeenew67': coffeenew67,
    'coffeenew68': coffeenew68,
    'coffeenew69': coffeenew69,
    'coffeenew70': coffeenew70,
    'coffeenew71': coffeenew71,
    'coffeenew72': coffeenew72,
    'coffeenew73': coffeenew73,
    'coffeenew74': coffeenew74,
    'coffeenew75': coffeenew75,
    'coffeenew76': coffeenew76,
    'coffeenew77': coffeenew77,
    'coffeenew78': coffeenew78,
    'coffeenew79': coffeenew79,
    'coffeenew80': coffeenew80,
    'coffeenew81': coffeenew81,
    'coffeenew82': coffeenew82,
    'coffeenew83': coffeenew83,
    'coffeenew84': coffeenew84,
    'coffeenew85': coffeenew85,
    'coffeenew86': coffeenew86,
    'coffeenew87': coffeenew87,
    'coffeenew88': coffeenew88,
    'coffeenew89': coffeenew89,
    'coffeenew90': coffeenew90,
    'coffeenew91': coffeenew91,
    'coffeenew92': coffeenew92,
    'coffeenew93': coffeenew93
};
